module.exports = __webpack_public_path__ + "static/img/pin.56ed0413.png";